var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.00977,
    y: 4.74854,
    width: 14.5027,
    height: 14.5027,
    rx: 4.5,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5434 12.1064L16.5431 11.0411C16.543 10.5455 16.7877 10.0819 17.197 9.80228L19.6536 8.12392C20.6492 7.44372 21.9997 8.15668 21.9997 9.36246V14.6372C21.9997 15.843 20.6492 16.556 19.6536 15.8758L17.197 14.1974C16.7877 13.9178 16.543 13.4541 16.5432 12.9585L16.5434 12.1064Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15039 12H11.3706",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26074 14.1101L9.26074 9.88995",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentSelect);
export default __webpack_public_path__ + "static/media/appointment-select.0b5afa3052304de9be4acafc217665e6.svg";
export { ForwardRef as ReactComponent };